import { Checkbox, FormControlLabel } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { SxProps, Theme } from "@mui/material/styles";
import { FC, memo } from "react";
import { Control, Controller, FieldError } from "react-hook-form";

interface IMuiFormCheckbox {
  name: string;
  label: string;
  error?: FieldError;
  control: Control<any>;
}


const styles: Record<string, SxProps<Theme>> = {
  formControl: {
    width: "100%",

    "& .MuiCheckbox-root": {
      py: "2px"
    },

    "& .MuiTypography-root": {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "20px",
      color: "#25282D",
    },
  }
};


const MuiFormCheckbox: FC<IMuiFormCheckbox> = ({
  label,
  name,
  error,
  control,
}) => {
  return (
    <FormControl error={Boolean(error?.message)} sx={styles.formControl}>
      <Controller
        render={({ field: { value, ...otherField } }) => (
          <FormControlLabel
            control={<Checkbox checked={value} id={name} {...otherField} />}
            label={label}
          />
        )}
        name={name}
        control={control}
      />

      {error?.message && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
};

export default memo(MuiFormCheckbox);
